import { yupResolver } from '@hookform/resolvers/yup';
import { useForm as useReactForm } from 'react-hook-form';
import * as yup from 'yup';
import { setLocale } from 'yup';
import * as ja from 'yup-locale-ja';

setLocale(ja.suggestive);
export const useForm = <Scheme>(schema: yup.AnyObjectSchema) => {
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    // @ts-ignore
  } = useReactForm<Scheme>({
    resolver: yupResolver(schema),
  });
  return { watch, register, handleSubmit, errors, control, setValue };
};

export const yupEmail = yup
  .string()
  .email()
  .required('有効なメールアドレスを入力してください');
export const yupImage = yup.object({
  file: yup.mixed().required(),
  title: yup.string().required(),
});
export type YupImageType = yup.InferType<typeof yupImage>;
